var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",staticStyle:{"width":"100%"}},[(_vm.loading)?_c('div',{staticStyle:{"min-height":"2px"}},[_c('v-progress-linear',{attrs:{"indeterminate":""}})],1):_vm._e(),_c('div',{staticClass:"d-flex",staticStyle:{"width":"100%"}},[_c('filter-sidebar-vue',{attrs:{"filter":_vm.filter},on:{"update:filter":function($event){_vm.filter=$event}}}),_c('div',{staticClass:"d-flex flex-column",staticStyle:{"width":"100%"}},[_c('data-section-vue',{attrs:{"printList":_vm.orders.filter(
            (o) =>
              o.workspace === _vm.filter.workspace ||
              _vm.filter.workspace === '전체 작업장'
          )}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }